import { get, post } from  "@/utils/request";

/**
 * 分页获取版本信息
 */

export const getDogsEditionListPage = data => post('edition/getDogsEditionListPage', data);

/**
 * 添加版本信息
 */
export const saveDogsEdition = data => post('edition/saveDogsEdition', data);



// WEBPACK FOOTER //
// ./src/api/edition.js